'use strict';

module.exports = ['Flat fee', 'Percentage of menu', 'No Fee'];